import verticalDotsSVG from "@/views/SVG/verticalDotsSVG";
import verifiedUserSVG from "@/views/SVG/verifiedUser";
import nonverifiedUserSVG from "@/views/SVG/nonverifiedUser";
import filterSVG from "@/views/SVG/funnel";
import ambulanceSVG from "@/views/SVG/ambulance.vue";
import downArrowSVG from "@/views/SVG/down-arrow";
import incomeSVG from "@/views/SVG/incomeSVG";
import searchSVG from "@/views/SVG/searchSVG";
import crossSVG from "@/views/SVG/crossSVG";
import messageSVG from "@/views/SVG/MessageSVG";
import phoneSVG from "@/views/SVG/PhoneSVG";
import emailSVG from "@/views/SVG/EmailIcon";
import pdfSVG from "@/views/SVG/pdf";
import sendSVG from "@/views/SVG/sendSVG";
import chevronSVG from "@/views/SVG/chevronRight";
import attachmentSVG from "@/views/SVG/attachmentSVG";
import fileSVG from "@/views/SVG/fileSVG";
import flagIcon from "@/views/SVG/FlagIcon";
import download from "@/views/SVG/download";
import printer from "@/views/SVG/printer";
import deleteSVG from "@/views/SVG/delete";
import doctorSVG from "@/views/SVG/doctor";
import medicalRecordSVG from "@/views/SVG/medicalRecord";
import upArrowSVG from "@/views/SVG/arrowUp";
import diagnosticSVG from "@/views/SVG/test";
import calendarSVG from "@/views/SVG/calendar";
import pharmacySVG from "@/views/SVG/drug";
import InfoIconSVG from "@/views/SVG/InfoIconSVG";
import leftarrowSVG from "@/views/SVG/left-arrow.vue";
import RightarrowSVG from "@/views/SVG/right-arrow.vue";
import featureSVG from "@/views/SVG/new-feature.vue";
let svgRegistries = {
  verticalDotsSVG,
  verifiedUserSVG,
  nonverifiedUserSVG,
  filterSVG,
  downArrowSVG,
  incomeSVG,
  searchSVG,
  crossSVG,
  messageSVG,
  phoneSVG,
  emailSVG,
  pdfSVG,
  sendSVG,
  attachmentSVG,
  fileSVG,
  flagIcon,
  download,
  printer,
  deleteSVG,
  chevronSVG,
  doctorSVG,
  ambulanceSVG,
  medicalRecordSVG,
  upArrowSVG,
  diagnosticSVG,
  calendarSVG,
  pharmacySVG,
  InfoIconSVG,
  leftarrowSVG,
  RightarrowSVG,
  featureSVG,
};
let pickSvg = (...args) => {
  let wrap = ({ ...args }) => ({ ...args });
  return wrap(svgRegistries);
};

export { pickSvg, svgRegistries };
